import { MAP_LABELS_ENABLED } from '/settings.js';
import { getCurrentLanguage } from '../translations/translations.js';

let mapLabelsLayer = null;
let loadedLabels = [];

export async function initMapLabels(map) {
    if (!MAP_LABELS_ENABLED) return;
    // Remove previous labels if any
    if (mapLabelsLayer) {
        map.removeLayer(mapLabelsLayer);
        mapLabelsLayer = null;
    }
    loadedLabels = [];

    // Load map-labels.json
    let labelsData;
    try {
        const resp = await fetch('/data/map-labels.json');
        if (!resp.ok) throw new Error('Failed to load map-labels.json');
        labelsData = await resp.json();
    } catch (e) {
        console.error('Could not load map-labels.json:', e);
        return;
    }

    // Create a layer group for labels
    mapLabelsLayer = L.layerGroup();

    // Get language
    const lang = getCurrentLanguage();

    // Add each label as a divIcon marker (with dynamic anchor)
    labelsData.forEach(labelObj => {
        let label = labelObj[`name_${lang}`] || labelObj['name_en'] || labelObj['name_es'] || labelObj['name_de'] || '';
        if (!label) return;
        const sizeClass = `map-label-size-${labelObj.size || 3}`;
        const colorStyle = labelObj.color ? `color:${labelObj.color};` : '';
        const html = `<span class='map-label-label ${sizeClass}' style='${colorStyle}' aria-label='${label}'>${label}</span>`;
        // Initial icon with no anchor (will update after render)
        let icon = L.divIcon({
            html,
            className: 'map-label-divicon',
            iconSize: null,
            iconAnchor: [0, 0]
        });
        const marker = L.marker([labelObj.latitude, labelObj.longitude], {
            icon,
            interactive: false
        });
        marker.addTo(mapLabelsLayer);
        loadedLabels.push(marker);

        // After marker is added, update anchor dynamically
        setTimeout(() => {
            const markerElem = marker.getElement();
            if (markerElem) {
                const labelElem = markerElem.querySelector('.map-label-label');
                if (labelElem) {
                    const width = labelElem.offsetWidth;
                    const height = labelElem.offsetHeight;
                    // Update icon with centered anchor
                    const newIcon = L.divIcon({
                        html,
                        className: 'map-label-divicon',
                        iconSize: [width, height],
                        iconAnchor: [width / 2, height / 2]
                    });
                    marker.setIcon(newIcon);
                }
            }
        }, 0);
    });

    mapLabelsLayer.addTo(map);

    // Listen for language changes
    window.removeEventListener('languageChanged', updateMapLabelsLang);
    window.addEventListener('languageChanged', updateMapLabelsLang);

    function updateMapLabelsLang() {
        if (!mapLabelsLayer) return;
        mapLabelsLayer.clearLayers();
        const newLang = getCurrentLanguage();
        labelsData.forEach(labelObj => {
            let label = labelObj[`name_${newLang}`] || labelObj['name_en'] || labelObj['name_es'] || labelObj['name_de'] || '';
            if (!label) return;
            const sizeClass = `map-label-size-${labelObj.size || 3}`;
            const colorStyle = labelObj.color ? `color:${labelObj.color};` : '';
            const html = `<span class='map-label-label ${sizeClass}' style='${colorStyle}' aria-label='${label}'>${label}</span>`;
            let icon = L.divIcon({
                html,
                className: 'map-label-divicon',
                iconSize: null,
                iconAnchor: [0, 0]
            });
            const marker = L.marker([labelObj.latitude, labelObj.longitude], {
                icon,
                interactive: false
            });
            marker.addTo(mapLabelsLayer);
            // After marker is added, update anchor dynamically
            setTimeout(() => {
                const markerElem = marker.getElement();
                if (markerElem) {
                    const labelElem = markerElem.querySelector('.map-label-label');
                    if (labelElem) {
                        const width = labelElem.offsetWidth;
                        const height = labelElem.offsetHeight;
                        const newIcon = L.divIcon({
                            html,
                            className: 'map-label-divicon',
                            iconSize: [width, height],
                            iconAnchor: [width / 2, height / 2]
                        });
                        marker.setIcon(newIcon);
                    }
                }
            }, 0);
        });
    }
} 